import React, { useState } from "react";
import PersonalizedActionModal from "../Modals/PersonalizedActionModal";
import Popups from "../Modals/Popups";

export default function AiCta() {
  const [show, setShow] = useState(false);
  return (
    <React.Fragment>
      <div className="row px-3 px-md-0 mx-0 py-4 py-md-0 aiCtaDiv mt-4 mb-5 align-items-center flex-column-reverse flex-md-row">
        <div className="col-md-5 ps-0 ps-md-5 mt-5 text-center text-md-start mt-md-0">
          <h2>Start Your AI Transformation Journey Today.</h2>
          <button
            class="ai-TalkBtn mt-2"
            onClick={() => {
              setShow(true);
            }}
          >
            <span class="ai-text-wrapper">
              <span class="ai-text ai-text-default">
                Let's Talk{" "}
                <img
                  className="ms-4"
                  src="/images/AboutUs/icons/arrow-right-hover.svg"
                  alt=""
                />
              </span>
              <span class="ai-text ai-text-hover">
                Let's Talk{" "}
                <img
                  className="ms-4"
                  src="/images/AboutUs/icons/arrow-right.svg"
                  alt=""
                />
              </span>
            </span>
          </button>
        </div>
        <div className="col-md-7">
          <img className="img-fluid" src="/images/AiCtaImage.png" alt="" />
        </div>
      </div>
      <Popups show={show} setShow={setShow} title="Let's Talk" size="lg">
        <PersonalizedActionModal />
      </Popups>
    </React.Fragment>
  );
}
